var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassDialog",
        {
          ref: "importDetailDialog",
          staticClass: "import-detail-dialog",
          attrs: {
            visible: _vm.showDialog,
            size: "large",
            title: _vm.$t.__(
              "settings.import.detail.ImportDetailPopup.import_detail"
            )
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            },
            closed: function($event) {
              return _vm.$emit("closed")
            }
          }
        },
        [
          !_vm.importDetail
            ? _c(
                "template",
                { slot: "default" },
                [
                  _c("CompassLoader", {
                    staticClass: "preloader-container__loader"
                  })
                ],
                1
              )
            : _c(
                "template",
                { slot: "default" },
                [
                  _vm.isImportInErrorOrCancelled
                    ? _c(
                        "div",
                        { class: _vm.restartImportAlertClasses },
                        [
                          _c("CompassAlert", {
                            ref: "alertImportOnError",
                            attrs: {
                              "show-close": false,
                              type: _vm.alertType,
                              description: _vm.alertMessage,
                              action: {
                                label: _vm.$t.__(
                                  "settings.import.detail.ImportDetailPopup.start_import_again"
                                ),
                                callback: function() {
                                  return _vm.onRestartImport(
                                    _vm.importTypeDetails
                                  )
                                }
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isImportV2
                    ? _c("CompassAlert", {
                        attrs: {
                          type: "warning",
                          description: _vm.$t.__(
                            "settings.import.detail.ImportDetailPopup.import_carried_out"
                          ),
                          action: {
                            label: _vm.$t.__(
                              "settings.import.detail.ImportDetailPopup.see_details_on_old_platform"
                            ),
                            callback: function() {
                              return _vm.goToDetailV2()
                            }
                          },
                          "show-close": false
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-container" },
                    [
                      _c("div", { staticClass: "card card-summary" }, [
                        _c("h4", { staticClass: "title" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Résumé")) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "line-container" },
                            [
                              _c("CompassIcon", {
                                attrs: {
                                  icon: "success-circle-fill",
                                  size: "small",
                                  type: "success"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "typographies-paragraph-x-large-bold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.getLabelForLine(
                                            _vm.importDetail,
                                            _vm.importDetail.processed_rows
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "typographies-paragraph-medium-semibold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$l10n.n__(
                                            "ligne traitée",
                                            "lignes traitées",
                                            _vm.importDetail.processed_rows,
                                            _vm.importDetail.processed_rows
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "line-container" },
                            [
                              _c("CompassIcon", {
                                attrs: {
                                  icon: "error-circle-fill",
                                  size: "small",
                                  type: "alert"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "typographies-paragraph-x-large-bold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.getLabelForLine(
                                            _vm.importDetail,
                                            _vm.importDetail.invalid_rows
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "typographies-paragraph-medium-semibold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$l10n.n__(
                                            "ligne en erreur",
                                            "lignes en erreurs",
                                            _vm.importDetail.invalid_rows,
                                            _vm.importDetail.invalid_rows
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      !_vm.isImportInErrorOrCancelled && !_vm.isImportV2
                        ? _vm._l(_vm.getDisplaySubTypeOrder, function(subType) {
                            return _c(
                              "div",
                              { key: subType, staticClass: "card card-type" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "title" },
                                  [
                                    _c("CompassIcon", {
                                      attrs: {
                                        icon: _vm.getImportIcon(subType),
                                        size: "medium"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h4",
                                      _vm._l(
                                        _vm.getImportTitleSegments(subType),
                                        function(ref) {
                                          var segment = ref.segment
                                          var classes = ref.classes
                                          return _c(
                                            "span",
                                            { class: classes },
                                            [_vm._v(_vm._s(segment))]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c("div", { staticClass: "line-container" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "typographies-paragraph-x-large-bold"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.getLabelForLine(
                                                _vm.importDetail,
                                                _vm.isInRevertStep
                                                  ? _vm.getSubTypeResultValues(
                                                      subType
                                                    ).deleted
                                                  : _vm.getSubTypeResultValues(
                                                      subType
                                                    ).created
                                              )
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.isInRevertStep
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "typographies-paragraph-medium-semibold"
                                          },
                                          [
                                            _vm.isSubTypeFemale(subType)
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$l10n.n__(
                                                          "supprimée",
                                                          "supprimées",
                                                          _vm.getSubTypeResultValues(
                                                            subType
                                                          ).deleted,
                                                          _vm.getSubTypeResultValues(
                                                            subType
                                                          ).deleted
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$l10n.n__(
                                                          "supprimé",
                                                          "supprimés",
                                                          _vm.getSubTypeResultValues(
                                                            subType
                                                          ).deleted,
                                                          _vm.getSubTypeResultValues(
                                                            subType
                                                          ).deleted
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ])
                                          ]
                                        )
                                      : _c(
                                          "p",
                                          {
                                            staticClass:
                                              "typographies-paragraph-medium-semibold"
                                          },
                                          [
                                            _vm.isSubTypeFemale(subType)
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$l10n.n__(
                                                          "ajoutée",
                                                          "ajoutées",
                                                          _vm.getSubTypeResultValues(
                                                            subType
                                                          ).created,
                                                          _vm.getSubTypeResultValues(
                                                            subType
                                                          ).created
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$l10n.n__(
                                                          "ajouté",
                                                          "ajoutés",
                                                          _vm.getSubTypeResultValues(
                                                            subType
                                                          ).created,
                                                          _vm.getSubTypeResultValues(
                                                            subType
                                                          ).created
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ])
                                          ]
                                        )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "line-container" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "typographies-paragraph-x-large-bold"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.getLabelForLine(
                                                _vm.importDetail,
                                                _vm.getSubTypeResultValues(
                                                  subType
                                                ).updated
                                              )
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "typographies-paragraph-medium-semibold"
                                      },
                                      [
                                        _vm.isSubTypeFemale(subType)
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$l10n.n__(
                                                      "mise à jour",
                                                      "mises à jour",
                                                      _vm.getSubTypeResultValues(
                                                        subType
                                                      ).updated,
                                                      _vm.getSubTypeResultValues(
                                                        subType
                                                      ).updated
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$l10n.__("mis à jour")
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ])
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            )
                          })
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "tab-container typographies-paragraph-medium-semibold"
                    },
                    [
                      _c("div", { ref: "slider", staticClass: "slider" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "tabInformation",
                          staticClass: "tab",
                          class: { selected: _vm.tabSelectedIsInformation },
                          on: {
                            click: function($event) {
                              return _vm.onTabSelected(
                                "tabInformation",
                                _vm.tabs.INFORMATIONS
                              )
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$l10n.__("Informations et actions")
                                ) +
                                "\n                    "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "tabSettings",
                          staticClass: "tab",
                          class: { selected: !_vm.tabSelectedIsInformation },
                          on: {
                            click: function($event) {
                              return _vm.onTabSelected(
                                "tabSettings",
                                _vm.tabs.SETTINGS
                              )
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$l10n.__("Paramètres de l’import")) +
                                "\n                    "
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "Transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _c(_vm.currentTabComponent, {
                        tag: "component",
                        staticClass: "mb-5",
                        attrs: { "is-import-v2": _vm.isImportV2 }
                      })
                    ],
                    1
                  )
                ],
                1
              )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }